<script>
  import {
    dbClearAllInvalidItems,
    clearAllInvalidItems,
    invalidateItem,
    user_data,
    parseCityStateZip,
  } from "./stores.js";
  import * as yup from "yup";
  import Cleave from "cleave.js";
  import { onMount } from "svelte";
  import Progresscomponent from "./components/progresscomponent.svelte";
  import Chipscompnent from "./components/chipscompnent.svelte";
  import Dtemplate from "./components/detailedtemplate.svelte";

  let property_value_element;
  let loan_balance_element;
  let property_value_formatter;
  let loan_value_formatter;

  onMount(async () => {
    property_value_formatter = new Cleave(property_value_element, {
      numeral: true,
      prefix: "$",
      noImmediatePrefix: true,
    });
    loan_value_formatter = new Cleave(loan_balance_element, {
      numeral: true,
      prefix: "$",
      noImmediatePrefix: true,
    });
  });

  const formSchema = yup.object().shape({
    property_value_element: yup
      .string()
      .required("Estimated home value is required to find the best rates."),
    loan_balance_element: yup
      .string()
      .required(
        "Estimated remaining loan balance is required to find the best rates."
      ),
  });
  async function checkNext() {
    clearAllInvalidItems();
    let res = false;
    await formSchema
      .validate({
        property_value_element: property_value_element.value.trim(),
        loan_balance_element: loan_balance_element.value.trim(),
      })
      .then(function (value) {
        res = true;
      })
      .catch(function (err) {
        invalidateItem(eval(err.path), err.errors[0]);
        res = false;
      });

    // check home value limit
    if (res) {
      if (
        parseInt(property_value_element.value.trim().toString().replace(/[^\d.-]/g, "")) >= 1 &&
        parseInt(property_value_element.value.trim().toString().replace(/[^\d.-]/g, "")) <= 10000000
      ) {
        res = true;
      } else {
        invalidateItem(
            property_value_element,
          "The home value must be between $1 and $10,000,000"
        );
        res = false;
      }
    }

    // check loan balance limit
    if (res) {
      if (
        parseInt(loan_balance_element.value.trim().toString().replace(/[^\d.-]/g, "")) >= 0 &&
        parseInt(loan_balance_element.value.trim().toString().replace(/[^\d.-]/g, "")) <= 2000000
      ) {
        res = true;
      } else {
        invalidateItem(
            loan_balance_element,
          "The current balance must be between $0 and $2,000,000"
        );
        res = false;
      }
    }

    return res;
  }

  function clearFunction() {
    dbClearAllInvalidItems();
  }
</script>

<Dtemplate progress_mobile_version={true}>
  <Progresscomponent
    pre_next_callback_function={checkNext}
    title="What's your estimated home value?"
  >
    <div class="formcontainer">
      <input
        inputmode="numeric"
        on:keyup={() => {
          clearFunction();
        }}
        bind:this={property_value_element}
        bind:value={$user_data.propertyvalue}
        type="text"
        placeholder="Home Value"
      />
    </div>
    <div class="formcontainer">
      <input
        inputmode="numeric"
        on:keyup={() => {
          clearFunction();
        }}
        bind:this={loan_balance_element}
        bind:value={$user_data.currentbalance}
        type="text"
        placeholder="Loan Balance"
      />
    </div>
  </Progresscomponent>
</Dtemplate>

<style>
  .formcontainer {
    margin-top: 40px;
    width: 60%;
    max-width: 350px;
    margin-left: auto;
    margin-right: auto;
  }
  .formcontainer input {
    width: 100%;
    padding: 10px;
  }
  @media (max-device-width: 1024px), (max-width: 1023px) {
    .formcontainer {
      width: 100%;
      max-width: 280px;
    }
  }
</style>
